import moment from 'moment-timezone';
import React, { useEffect, useState, useRef, useContext } from 'react'
import { Col, Container, Form, FormControl, InputGroup, Row, Tab, Tabs } from 'react-bootstrap'
import { useImmer } from 'use-immer';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
//import { Scheduler } from "@aldabil/react-scheduler";
import '../css/statistics.css'
import GlobalContext from '../GlobalContext';
import { useNavigate } from 'react-router-dom';
import { RiDeleteBin6Line, RiEditBoxLine, RiCheckLine, RiCloseLine, RiEraserLine, RiMenuAddLine, RiMessage2Line } from 'react-icons/ri'
import { MdOutlineMailOutline, MdPersonSearch, MdSearchOff } from 'react-icons/md'
import GoodSwitch from '../components/GoodSwitch';
import Sidebar from './Sidebar';
import Leftbar from './Leftbar';
import { AreaChart, BarChart, DonutChart } from '../components/Charts';
import ServiceContext from '../ServiceContext';
import TextContext from '../TextContext';


const checkNumber = (number) => {
   const continuos = number.split(" ").join("")
   //console.log("HEY",continuos)
   return (isInteger(continuos) && continuos.length > 6 && continuos.length < 15)
}
const compareApt = (a, b) => {
   if (a.Events.length == 0 || b.Events.length == 0) {
      return 0;
   }
   if (a.Events[0].eve_start > b.Events[0].eve_start) {
      return -1;
   }
   if (a.Events[0].eve_start < b.Events[0].eve_start) {
      return 1;
   }
   return 0;
}
const defaAddFormValues = {
   cus_name: "",
   cus_surname: "",
   cus_email: "",
   cus_enable_sms: false,
   cus_enable_wa: true,
   cus_enable_email: false,
   phn_prefix: "+41",
   phn_number: "",
   cus_notes: ''
}

const isInteger = (number) => {
   if (!/^["|']{0,1}[-]{0,1}\d{0,}(.{0,1}\d+)["|']{0,1}$/.test(number)) return false;
   return !(number - parseInt(number));
}
const sortList = (list, compareFunc) => {
   let newList = []
   list.forEach(element => {
      if (newList.length == 0) {
         newList.push(element)
      } else {
         let skip = false
         newList.forEach((v, i) => {
            if (!skip) {
               const comp = compareFunc(element, v)
               if (comp != -1) {
                  if (i == 0) {
                     newList = [element, ...newList]
                  } else {
                     newList = [...newList.slice(0, i), element, ...newList.slice(i)]
                  }
                  skip = true
               } else {
                  if ((i + 1) == newList.length) {
                     newList.push(element)
                  }
               }
            }
         })
      }
   })
   return newList
}
const Statistics = () => {

   const globalContext = useContext(GlobalContext)
   const serviceContext = useContext(ServiceContext)
   const textContext = useContext(TextContext)
   const navigate = useNavigate()
   const animatedComponents = makeAnimated()

   const graphOptions = [
      { label:  textContext.get(['Statistics', 'stats'], ['isto'], textContext.value), value: 0 },
      { label: textContext.get(['Statistics', 'stats'], ['linea'], textContext.value), value: 1 },
   ]
   const graphIntervalOptions = [
      { label: textContext.get(['Statistics', 'stats'], ['year'], textContext.value), value: 0 },
      { label: textContext.get(['Statistics', 'stats'], ['month'], textContext.value), value: 1 },
      { label:  textContext.get(['Statistics', 'stats'], ['week'], textContext.value), value: 2 },
      { label: textContext.get(['Statistics', 'stats'], ['day_w'], textContext.value), value: 3 },
      { label:  textContext.get(['Statistics', 'stats'], ['day'], textContext.value), value: 4 },
   ]

   const [selectedShop, setSelectedShop] = useState(globalContext.get.Shop.ID)
   const [selectedGraph, setSelectedGraph] = useState({ label: textContext.get(['Statistics', 'stats'], ['isto'], textContext.value), value: 0 })
   const [selectedGraphInterval, setSelectedGraphInterval] = useState({ label: textContext.get(['Statistics', 'stats'], ['day'], textContext.value), value: 4 })
   const [selectedProperty, setSelectedProperty] = useState('income')
   const [graphStart, setGraphStart] = useState(moment().utc().subtract(1, 'month').startOf('day').unix())
   const [graphEnd, setGraphEnd] = useState(moment().utc().startOf('day').unix())
   const [data, setData] = useState({})
   const [dataset, setDataset] = useImmer({ labels: [], datasets: [], tooltipLabels: [], min: 0, max: 0, tot: 0, avg: 0 })
   const dataLoaded=useRef(false);


   const getPermission = (permission, pos = -1) => {
      if (globalContext.get) {
         if (globalContext.get.User) {
            if (globalContext.get.User.Groups) {
               if (globalContext.get.User.Groups.length > 0) {
                  if (globalContext.get.User.Groups[0].gro_is_admin) {
                     return true
                  } else {
                     if (pos >= 0) {
                        return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                     } else {
                        return globalContext.get.User.Groups[0][permission]
                     }
                  }
               }
            }
         }
      }
      return false
   }
   const getBaseStats = async () => {

      const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/stats?shop=${selectedShop}&start=${graphStart}&end=${graphEnd}`, {
         method: 'GET',
         credentials: 'include'
      })
      const respValue = await resp.json()

      if (resp.status == 200) {
         dataLoaded.current=true
         setData(respValue.data)
      }
   }
   const genLabels = () => {
      if (selectedGraphInterval.value == 1) {
         return genMonths(graphStart, graphEnd)
      } else if (selectedGraphInterval.value == 2) {
         return genWeeks(graphStart, graphEnd)
      } else if (selectedGraphInterval.value == 0) {
         return genYears(graphStart, graphEnd)
      } else if (selectedGraphInterval.value == 4) {
         return genDays(graphStart, graphEnd)
      } else if (selectedGraphInterval.value == 3) {
         return [textContext.get(['Statistics', 'stats'], ['lun'], textContext.value),textContext.get(['Statistics', 'stats'], ['mar'], textContext.value), textContext.get(['Statistics', 'stats'], ['mer'], textContext.value), textContext.get(['Statistics', 'stats'], ['gio'], textContext.value), textContext.get(['Statistics', 'stats'], ['ven'], textContext.value), textContext.get(['Statistics', 'stats'], ['sab'], textContext.value), textContext.get(['Statistics', 'stats'], ['dom'], textContext.value)]
      }
      return []
   }
   const genData = (property) => {
      const labels = genLabels()
      let color='#3a4fa4'
      if(globalContext.get){
         if(globalContext.get.Theme){
            if(globalContext.get.Theme.palette){
               if(globalContext.get.Theme.palette.length>=6){
                  color=globalContext.get.Theme.palette[6]
               }
            }
         }
      }
      if (['income', 'sms_expense'].includes(property)) {
         const values = JSON.parse(JSON.stringify(data))
         if (selectedGraphInterval.value == 0) {
            const dataList = []
            labels.forEach(year => {
               let total = 0
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').format('YYYY') == year) {
                     total += values[day][property]
                  }
               })
               dataList.push(total)
            })
            setDataset({
               labels,
               tooltipLabels: dataList,
               datasets: [
                  {
                     label: property == 'income' ?  textContext.get(['Statistics', 'stats'], ['incasso'], textContext.value) : textContext.get(['Statistics', 'stats'], ['sms'], textContext.value),
                     data: dataList,
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 1) {
            const dataList = []
            labels.forEach(month => {
               let total = 0
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').format('MM/YY') == month) {
                     total += values[day][property]
                  }
               })
               dataList.push(total)
            })
            setDataset({
               labels,
               tooltipLabels: dataList,
               datasets: [
                  {
                     label: property == 'income' ? textContext.get(['Statistics', 'stats'], ['incasso'], textContext.value) : textContext.get(['Statistics', 'stats'], ['sms'], textContext.value),
                     data: dataList,
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 2) {
            const dataList = []
            labels.forEach(week => {
               let total = 0
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').startOf('week').format('DD/MM') == week) {
                     total += values[day][property]
                  }
               })
               dataList.push(total)
            })
            setDataset({
               labels,
               tooltipLabels: dataList,
               datasets: [
                  {
                     label: property == 'income' ? textContext.get(['Statistics', 'stats'], ['incasso'], textContext.value) : textContext.get(['Statistics', 'stats'], ['sms'], textContext.value),
                     data: dataList,
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 4) {
            const dataList = []
            labels.forEach(dayLabel => {
               let total = 0
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').format('DD/MM/YY') == dayLabel) {
                     total += values[day][property]
                  }
               })
               dataList.push(total)
            })
            setDataset({
               labels,
               tooltipLabels: dataList,
               datasets: [
                  {
                     label: property == 'income' ? textContext.get(['Statistics', 'stats'], ['incasso'], textContext.value) : textContext.get(['Statistics', 'stats'], ['sms'], textContext.value),
                     data: dataList,
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color,
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 3) {
            const dataList = []
            labels.forEach((weekDay, index) => {
               let total = 0
               Object.keys(values).forEach(day => {
                  if ((moment(day, 'YYYY-MM-DD').isoWeekday() - 1) == index) {
                     total += values[day][property]
                  }
               })
               dataList.push(total)
            })
            setDataset({
               labels,
               tooltipLabels: dataList,
               datasets: [
                  {
                     label: property == 'income' ?  textContext.get(['Statistics', 'stats'], ['incasso'], textContext.value) : textContext.get(['Statistics', 'stats'], ['sms'], textContext.value),
                     data: dataList,
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         }
      } else if (['best_category', 'best_customer'].includes(property)) {
         const values = JSON.parse(JSON.stringify(data))
         if (selectedGraphInterval.value == 0) {
            const dataList = []
            labels.forEach(year => {
               let max = undefined
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').format('YYYY') == year) {
                     if (values[day][property]) {
                        if (max) {
                           if (max.value < values[day][property].value) {
                              max = values[day][property]
                           }
                        } else {
                           max = values[day][property]
                        }
                     }
                  }
               })
               dataList.push(max)
            })
            if (property == "best_category") {
               dataList.forEach((cat, index) => {
                  let category = globalContext.get.categories.filter(cati => cati.ID == parseInt(cat.ID))
                  if (category.length > 0) {
                     dataList[index].label = category[0].cat_name
                  } else {
                     dataList[index].label =  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value)
                  }
               })
            } else {
               dataList.forEach((cus, index) => {
                  let customer = globalContext.get.customers.filter(cusi => cusi.ID == parseInt(cus.ID))
                  if (customer.length > 0) {
                     dataList[index].label = `${customer[0].cus_name} ${customer[0].cus_surname}`
                  } else {
                     dataList[index].label = textContext.get(['Statistics', 'stats'], ['none_client'], textContext.value)
                  }
               })
            }
            setDataset({
               labels,
               tooltipLabels: dataList.map(cat => cat.label),
               datasets: [
                  {
                     label: property == 'best_category' ? textContext.get(['Statistics', 'stats'], ['best_cate'], textContext.value) : textContext.get(['Statistics', 'stats'], ['best_cust'], textContext.value),
                     data: dataList.map(cat => cat.value),
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 1) {
            const dataList = []
            labels.forEach(month => {
               let max = { ID: 0, value: 0 }
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').format('MM/YY') == month) {
                     if (values[day][property]) {
                        if (max) {
                           if (max.value < values[day][property].value) {
                              max = values[day][property]
                           }
                        } else {
                           max = values[day][property]
                        }
                     }
                  }
               })
               dataList.push(max)
            })
            if (property == "best_category") {
               dataList.forEach((cat, index) => {
                  let category = globalContext.get.categories.filter(cati => cati.ID == parseInt(cat.ID))
                  if (category.length > 0) {
                     dataList[index].label = category[0].cat_name
                  } else {
                     dataList[index].label =  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value)
                  }
               })
            } else {
               dataList.forEach((cus, index) => {
                  let customer = globalContext.get.customers.filter(cusi => cusi.ID == parseInt(cus.ID))
                  if (customer.length > 0) {
                     dataList[index].label = `${customer[0].cus_name} ${customer[0].cus_surname}`
                  } else {
                     dataList[index].label = textContext.get(['Statistics', 'stats'], ['none_client'], textContext.value)
                  }
               })
            }
            setDataset({
               labels,
               tooltipLabels: dataList.map(cat => cat.label),
               datasets: [
                  {
                     label: property == 'best_category' ? textContext.get(['Statistics', 'stats'], ['best_cate'], textContext.value) : textContext.get(['Statistics', 'stats'], ['best_cust'], textContext.value),
                     data: dataList.map(cat => cat.value),
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 2) {
            const dataList = []
            labels.forEach(week => {
               let max = { ID: 0, value: 0 }
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').startOf('week').format('DD/MM') == week) {
                     if (values[day][property]) {
                        if (max) {
                           if (max.value < values[day][property].value) {
                              max = values[day][property]
                           }
                        } else {
                           max = values[day][property]
                        }
                     }
                  }
               })
               dataList.push(max)
            })
            if (property == "best_category") {
               dataList.forEach((cat, index) => {
                  let category = globalContext.get.categories.filter(cati => cati.ID == parseInt(cat.ID))
                  if (category.length > 0) {
                     dataList[index].label = category[0].cat_name
                  } else {
                     dataList[index].label =  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value)
                  }
               })
            } else {
               dataList.forEach((cus, index) => {
                  let customer = globalContext.get.customers.filter(cusi => cusi.ID == parseInt(cus.ID))
                  if (customer.length > 0) {
                     dataList[index].label = `${customer[0].cus_name} ${customer[0].cus_surname}`
                  } else {
                     dataList[index].label = textContext.get(['Statistics', 'stats'], ['none_client'], textContext.value)
                  }
               })
            }
            setDataset({
               labels,
               tooltipLabels: dataList.map(cat => cat.label),
               datasets: [
                  {
                     label: property == 'best_category' ? textContext.get(['Statistics', 'stats'], ['best_cate'], textContext.value) : textContext.get(['Statistics', 'stats'], ['best_cust'], textContext.value),
                     data: dataList.map(cat => cat.value),
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 4) {
            const dataList = []
            labels.forEach(dayInterval => {
               let max = { ID: 0, value: 0 }
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').format('DD/MM/YY') == dayInterval) {
                     if (values[day][property]) {
                        if (max) {
                           if (max.value < values[day][property].value) {
                              max = values[day][property]
                           }
                        } else {
                           max = values[day][property]
                        }
                     }
                  }
               })
               dataList.push(max)
            })
            if (property == "best_category") {
               dataList.forEach((cat, index) => {
                  let category = globalContext.get.categories.filter(cati => cati.ID == parseInt(cat.ID))
                  if (category.length > 0) {
                     dataList[index].label = category[0].cat_name
                  } else {
                     dataList[index].label =  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value)
                  }
               })
            } else {
               dataList.forEach((cus, index) => {
                  let customer = globalContext.get.customers.filter(cusi => cusi.ID == parseInt(cus.ID))
                  if (customer.length > 0) {
                     dataList[index].label = `${customer[0].cus_name} ${customer[0].cus_surname}`
                  } else {
                     dataList[index].label = textContext.get(['Statistics', 'stats'], ['none_client'], textContext.value)
                  }
               })
            }
            setDataset({
               labels,
               tooltipLabels: dataList.map(cat => cat.label),
               datasets: [
                  {
                     label: property == 'best_category' ?textContext.get(['Statistics', 'stats'], ['best_cate'], textContext.value) : textContext.get(['Statistics', 'stats'], ['best_cust'], textContext.value),
                     data: dataList.map(cat => cat.value),
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 3) {
            const dataList = []
            labels.forEach((weekDay, index) => {
               let max = { ID: 0, value: 0 }
               Object.keys(values).forEach(day => {
                  if ((moment(day, 'YYYY-MM-DD').isoWeekday() - 1) == index) {
                     if (values[day][property]) {
                        if (max) {
                           if (max.value < values[day][property].value) {
                              max = values[day][property]
                           }
                        } else {
                           max = values[day][property]
                        }
                     }
                  }
               })
               dataList.push(max)
            })
            if (property == "best_category") {
               dataList.forEach((cat, index) => {
                  let category = globalContext.get.categories.filter(cati => cati.ID == parseInt(cat.ID))
                  if (category.length > 0) {
                     dataList[index].label = category[0].cat_name
                  } else {
                     dataList[index].label =  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value)
                  }
               })
            } else {
               dataList.forEach((cus, index) => {
                  let customer = globalContext.get.customers.filter(cusi => cusi.ID == parseInt(cus.ID))
                  if (customer.length > 0) {
                     dataList[index].label = `${customer[0].cus_name} ${customer[0].cus_surname}`
                  } else {
                     dataList[index].label = textContext.get(['Statistics', 'stats'], ['none_client'], textContext.value)
                  }
               })
            }
            setDataset({
               labels,
               tooltipLabels: dataList.map(cat => cat.label),
               datasets: [
                  {
                     label: property == 'best_category' ? textContext.get(['Statistics', 'stats'], ['best_cate'], textContext.value) : textContext.get(['Statistics', 'stats'], ['best_cust'], textContext.value),
                     data: dataList.map(cat => cat.value),
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         }
      } else if (['worst_category'].includes(property)) {
         const values = JSON.parse(JSON.stringify(data))
         if (selectedGraphInterval.value == 0) {
            const dataList = []
            labels.forEach(year => {
               let min = undefined
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').format('YYYY') == year) {
                     if (values[day][property]) {
                        if (min) {
                           if (min.value > values[day][property].value) {
                              min = values[day][property]
                           }
                        } else {
                           min = values[day][property]
                        }
                     }
                  }
               })
               dataList.push(min)
            })
            dataList.forEach((cat, index) => {
               if (!cat) {
                  dataList[index] = { label:  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value) }
                  return
               }
               let category = globalContext.get.categories.filter(cati => cati.ID == parseInt(cat.ID))
               if (category.length > 0) {
                  dataList[index].label = category[0].cat_name
               } else {
                  dataList[index].label =  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value)
               }
            })
            setDataset({
               labels,
               tooltipLabels: dataList.map(cat => cat.label),
               datasets: [
                  {
                     label: textContext.get(['Statistics', 'stats'], ['worst_cate'], textContext.value),
                     data: dataList.map(cat => cat.value),
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 1) {
            const dataList = []
            labels.forEach(month => {
               let min = undefined
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').format('MM/YY') == month) {
                     if (values[day][property]) {
                        if (min) {
                           if (min.value > values[day][property].value) {
                              min = values[day][property]
                           }
                        } else {
                           min = values[day][property]
                        }
                     }
                  }
               })
               dataList.push(min)
            })
            dataList.forEach((cat, index) => {
               if (!cat) {
                  dataList[index] = { label:  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value) }
                  return
               }
               let category = globalContext.get.categories.filter(cati => cati.ID == parseInt(cat.ID))
               if (category.length > 0) {
                  dataList[index].label = category[0].cat_name
               } else {
                  dataList[index].label = textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value)
               }
            })
            setDataset({
               labels,
               tooltipLabels: dataList.map(cat => cat.label),
               datasets: [
                  {
                     label: textContext.get(['Statistics', 'stats'], ['worst_cate'], textContext.value),
                     data: dataList.map(cat => cat.value),
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 2) {
            const dataList = []
            labels.forEach(week => {
               let min = undefined
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').startOf('week').format('DD/MM') == week) {
                     if (values[day][property]) {
                        if (min) {
                           if (min.value > values[day][property].value) {
                              min = values[day][property]
                           }
                        } else {
                           min = values[day][property]
                        }
                     }
                  }
               })
               dataList.push(min)
            })
            dataList.forEach((cat, index) => {
               if (!cat) {
                  dataList[index] = { label:  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value) }
                  return
               }
               let category = globalContext.get.categories.filter(cati => cati.ID == parseInt(cat.ID))
               if (category.length > 0) {
                  dataList[index].label = category[0].cat_name
               } else {
                  dataList[index].label =  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value)
               }
            })
            setDataset({
               labels,
               tooltipLabels: dataList.map(cat => cat.label),
               datasets: [
                  {
                     label: textContext.get(['Statistics', 'stats'], ['worst_cate'], textContext.value),
                     data: dataList.map(cat => cat.value),
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 4) {
            const dataList = []
            labels.forEach(dayInterval => {
               let min = undefined
               Object.keys(values).forEach(day => {
                  if (moment(day, 'YYYY-MM-DD').format('DD/MM/YY') == dayInterval) {
                     if (values[day][property]) {
                        if (min) {
                           if (min.value > values[day][property].value) {
                              min = values[day][property]
                           }
                        } else {
                           min = values[day][property]
                        }
                     }
                  }
               })
               dataList.push(min)
            })
            dataList.forEach((cat, index) => {
               if (!cat) {
                  dataList[index] = { label: textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value) }
                  return
               }
               let category = globalContext.get.categories.filter(cati => cati.ID == parseInt(cat.ID))
               if (category.length > 0) {
                  dataList[index].label = category[0].cat_name
               } else {
                  dataList[index].label = textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value)
               }
            })
            setDataset({
               labels,
               tooltipLabels: dataList.map(cat => cat.label),
               datasets: [
                  {
                     label:  textContext.get(['Statistics', 'stats'], ['worst_cate'], textContext.value),
                     data: dataList.map(cat => cat.value),
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         } else if (selectedGraphInterval.value == 3) {
            const dataList = []
            labels.forEach((weekDay, index) => {
               let min = undefined
               Object.keys(values).forEach(day => {
                  if ((moment(day, 'YYYY-MM-DD').isoWeekday() - 1) == index) {
                     if (values[day][property]) {
                        if (min) {
                           if (min.value > values[day][property].value) {
                              min = values[day][property]
                           }
                        } else {
                           min = values[day][property]
                        }
                     }
                  }
               })
               dataList.push(min)
            })
            dataList.forEach((cat, index) => {
               if (!cat) {
                  dataList[index] = { label:  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value) }
                  return
               }
               let category = globalContext.get.categories.filter(cati => cati.ID == parseInt(cat.ID))
               if (category.length > 0) {
                  dataList[index].label = category[0].cat_name
               } else {
                  dataList[index].label =  textContext.get(['Statistics', 'stats'], ['none_category'], textContext.value)
               }
            })
            setDataset({
               labels,
               tooltipLabels: dataList.map(cat => cat.label),
               datasets: [
                  {
                     label: textContext.get(['Statistics', 'stats'], ['worst_cate'], textContext.value),
                     data: dataList.map(cat => cat.value),
                     backgroundColor: 'rgba(255, 99, 132, 0.5)',
                     color: color
                  },
               ]
            })
         }
      }
   }
   const genDays = (start, end) => {
      start = moment(start, 'X').startOf('day')
      const res = []
      do {
         res.push(start.format("DD/MM/YY"))
         start.add(1, 'day');
      } while (start.unix() < end)
      return res
   }
   const genMonths = (start, end) => {
      start = moment(start, 'X').startOf('month')
      const res = []
      do {
         res.push(start.format("MM/YY"))
         start.add(1, 'M');
      } while (start.unix() < end)
      return res
   }
   const genWeeks = (start, end) => {
      start = moment(start, 'X').startOf('week')
      const res = []
      do {
         res.push(start.format("DD/MM"))
         start.add(1, 'week');
      } while (start.unix() < end)
      return res
   }
   const genYears = (start, end) => {
      start = moment(start, 'X').startOf('year')
      const res = []
      do {
         res.push(start.format("YYYY"))
         start.add(1, 'year');
      } while (start.unix() < end)
      return res
   }
   const genGeneralStats=()=>{
      const stats={
         total: 0,
         max: 0,
         min: Number.MAX_VALUE,
         avg: []
      }
      if(dataset.datasets.length==0){
         return
      }
      const data=JSON.parse(JSON.stringify(dataset.datasets[0].data))
      data.forEach(interval=>{
         stats.total+=interval
         if(stats.max<interval){
            stats.max=interval
         }
         if(stats.min>interval){
            stats.min=interval
         }
         stats.avg.push(interval)
      })
      let avg= stats.avg.reduce((a, b) => a + b, 0)
      avg=parseFloat(Math.round((parseFloat(avg)/parseFloat(stats.avg.length))*100))/100
      stats.max=parseFloat(Math.round(stats.max*100))/100
      stats.min=parseFloat(Math.round(stats.min*100))/100
      stats.total=parseFloat(Math.round(stats.total*100))/100
      setDataset(draft=>{
         draft.avg=avg;
         draft.tot=stats.total;
         draft.max=stats.max;
         draft.min=stats.min;
      })
   }


   useEffect(()=>{
      if(!dataLoaded.current){
         getBaseStats()
      }
   },[])
   useEffect(() => {
      getBaseStats()
   }, [selectedShop, graphStart, graphEnd])
   useEffect(() => {
      genData(selectedProperty)
   }, [data, selectedGraphInterval, selectedProperty])
   useEffect(()=>{
      genGeneralStats()
   },[dataset])

   return (
      <>
         <Container fluid style={{ backgroundColor: globalContext.get.Theme.palette[1], height: '99.5%', margin: 0, color: globalContext.get.Theme.palette[3] }}>
            <Row className='' >
               <Sidebar />
               <Col xs={2} className='statistics-list-container'>
                  <div className='statistics-list-header nac-title' >
                  { textContext.get(['Statistics', 'stats'], ['title'], textContext.value) }
                  </div>
                  <div className='statistics-list-items'>
                     <div className={`statistics-list-item-selectable  ${selectedProperty == 'income' && 'statistics-list-item-selected'}`}>
                        <div
                           className={`nac-text statistics-list-databox`}
                           onClick={() => setSelectedProperty('income')}
                        >
                          { textContext.get(['Statistics', 'stats'], ['incasso'], textContext.value) }
                        </div>
                     </div>
                     <div className={`statistics-list-item-selectable  ${selectedProperty == 'sms_expense' && 'statistics-list-item-selected'}`}>
                        <div
                           className='nac-text statistics-list-databox'
                           onClick={() => setSelectedProperty('sms_expense')}
                        >
                           { textContext.get(['Statistics', 'stats'], ['sms'], textContext.value) }
                        </div>
                     </div>
                     <div className={`statistics-list-item-selectable  ${selectedProperty == 'best_customer' && 'statistics-list-item-selected'}`}>
                        <div
                           className='nac-text statistics-list-databox'
                           onClick={() => setSelectedProperty('best_customer')}
                        >
                           { textContext.get(['Statistics', 'stats'], ['best_cust'], textContext.value) }
                        </div>
                     </div>
                     <div className={`statistics-list-item-selectable  ${selectedProperty == 'best_category' && 'statistics-list-item-selected'}`}>
                        <div
                           className='nac-text statistics-list-databox'
                           onClick={() => setSelectedProperty('best_category')}
                        >
                          { textContext.get(['Statistics', 'stats'], ['best_cate'], textContext.value) }
                        </div>
                     </div>
                     <div className={`statistics-list-item-selectable  ${selectedProperty == 'worst_category' && 'statistics-list-item-selected'}`}>
                        <div
                           className='nac-text statistics-list-databox'
                           onClick={() => setSelectedProperty('worst_category')}
                        >
                          { textContext.get(['Statistics', 'stats'], ['worst_cate'], textContext.value) }
                        </div>
                     </div>
                  </div>
               </Col>
               <Col xs={7} className='statistics-detail-container'>
                  <div className='statistics-general-controls-container'>
                     <form>
                        <div className='statistics-detail-selects'>
                           <div className='statistics-detail-select' >
                              <Form.Label>
                              { textContext.get(['Statistics', 'stats'], ['type'], textContext.value) }
                              </Form.Label>
                              <Select
                                 id='select-pttp'
                                 components={animatedComponents}
                                 options={graphOptions}
                                 value={selectedGraph}
                                 onChange={(e) => setSelectedGraph(e)}
                              />
                           </div>
                           <div className='statistics-detail-select' >
                              <Form.Label>
                              { textContext.get(['Statistics', 'stats'], ['int'], textContext.value) }
                              </Form.Label>
                              <Select
                                 id='select-pttp'
                                 components={animatedComponents}
                                 options={graphIntervalOptions}
                                 value={selectedGraphInterval}
                                 onChange={(e) => setSelectedGraphInterval(e)}
                              />
                           </div>
                        </div>
                        <div className='statistics-detail-selects'>
                           <div className='statistics-detail-select' >
                              <Form.Label>
                              { textContext.get(['Statistics', 'stats'], ['dal'], textContext.value) }
                              </Form.Label>
                              <FormControl
                                 type='date'
                                 value={moment(graphStart, 'X').format('YYYY-MM-DD')}
                                 max={moment(graphEnd, 'X').subtract(1, 'day').format('YYYY-MM-DD')}
                                 onChange={(e) => setGraphStart(moment.utc(e.target.value, 'YYYY-MM-DD').unix())}
                              />
                           </div>
                           <div className='statistics-detail-select' >
                              <Form.Label>
                              { textContext.get(['Statistics', 'stats'], ['al'], textContext.value) }
                              </Form.Label>
                              <FormControl
                                 type='date'
                                 value={moment(graphEnd, 'X').format('YYYY-MM-DD')}
                                 min={moment(graphStart, 'X').add(1, 'day').format('YYYY-MM-DD')}
                                 onChange={(e) => setGraphEnd(moment.utc(e.target.value, 'YYYY-MM-DD').unix())}
                              />
                           </div>
                        </div>
                        <div className='statistics-detail-datas'>
                           <div className='nac-button statistics-detail-data'>
                           { textContext.get(['Statistics', 'stats'], ['max'], textContext.value) } {dataset.max}
                           </div>
                           <div className='nac-button statistics-detail-data'>
                           { textContext.get(['Statistics', 'stats'], ['min'], textContext.value) } {dataset.min}
                           </div>
                           <div className='nac-button statistics-detail-data'>
                           { textContext.get(['Statistics', 'stats'], ['med'], textContext.value) } {['income', 'sms_expense'].includes(selectedProperty)? dataset.avg : "N/A"}
                           </div>
                           <div className='nac-button statistics-detail-data'>
                           { textContext.get(['Statistics', 'stats'], ['tot'], textContext.value) }  {['income', 'sms_expense'].includes(selectedProperty)? dataset.tot : "N/A"}
                           </div>
                        </div>
                     </form>
                  </div>
                  <div className='statistics-general-graph-container'>
                     {selectedGraph.value == 0 ? (
                        <BarChart
                           color={globalContext.get.Theme.palette[6]}
                           data={dataset}
                        />
                     ) : selectedGraph.value == 1 ? (
                        <AreaChart
                           color={globalContext.get.Theme.palette[6]}
                           data={dataset}
                        />
                     ) : (
                        <DonutChart />
                     )}
                  </div>
               </Col>
               <Leftbar />
            </Row>
         </Container>
      </>
   )
}

export default Statistics




// < Row className = 'statistics-general-data-container' >
//                               <div className='statistics-general-data-item'>
//                                  <div className='statistics-general-data-header nac-title'>
//                                     Appuntamenti:
//                                  </div>
//                                  <div className='statistics-general-data-body'>
//                                     <div className='statistics-general-data-values'>
//                                        <div className='statistics-general-data-value'>
//                                           Media giornaliera: 12
//                                        </div>
//                                     </div>
//                                     <div className='statistics-general-data-values'>
//                                        <div className='statistics-general-data-value'>
//                                           Massimo al giorno: 44
//                                        </div>
//                                        <div className='statistics-general-data-value'>
//                                           Minimo al giorno: 4
//                                        </div>
//                                     </div>
//                                     <div className='statistics-general-data-values'>
//                                        <div className='statistics-general-data-value'>
//                                           Totale effettuati: 18
//                                        </div>
//                                        <div className='statistics-general-data-value'>
//                                           Totale Annullati: 2
//                                        </div>
//                                     </div>
//                                  </div>
//                               </div>
//                               <div className='statistics-general-data-item-reverse'>
//                                  <div className='statistics-general-data-header nac-title'>
//                                     Clienti:
//                                  </div>
//                                  <div className='statistics-general-data-body'>
//                                     <div className='statistics-general-data-values'>
//                                        <div className='statistics-general-data-value statistics-general-data-value-active'>
//                                           Totali: 20
//                                        </div>
//                                        <div className='statistics-general-data-value'>
//                                           Più affezzionato: Martina
//                                        </div>
//                                     </div>
//                                     <div className='statistics-general-data-values'>
//                                        <div className='statistics-general-data-value'>
//                                           Nuovi: 18
//                                        </div>
//                                        <div className='statistics-general-data-value'>
//                                           Ripetitivi: 2
//                                        </div>
//                                     </div>
//                                  </div>
//                               </div>
//                               <div className='statistics-general-data-item'>
//                                  <div className='statistics-general-data-header nac-title'>
//                                     Tempistiche:
//                                  </div>
//                                  <div className='statistics-general-data-body'>
//                                     <div className='statistics-general-data-values'>
//                                        <div className='statistics-general-data-value'>
//                                           Ora di punta: 15:00
//                                        </div>
//                                        <div className='statistics-general-data-value'>
//                                           Ore totali lavorate: 560
//                                        </div>
//                                     </div>
//                                     <div className='statistics-general-data-values'>
//                                        <div className='statistics-general-data-value'>
//                                           Categoria più frequente: Taglio
//                                        </div>
//                                        <div className='statistics-general-data-value'>
//                                           Categoria meno frequente: Eutanasia
//                                        </div>
//                                     </div>
//                                  </div>
//                               </div>
//                               <div className='statistics-general-data-item-reverse'>
//                                  <div className='statistics-general-data-header nac-title'>
//                                     Spese:
//                                  </div>
//                                  <div className='statistics-general-data-body'>
//                                     <div className='statistics-general-data-values'>
//                                        <div className='statistics-general-data-value'>
//                                           Spesa sms: 15 CHF
//                                        </div>
//                                        <div className='statistics-general-data-value'>
//                                           Spesa assistenza: 0 CHF
//                                        </div>
//                                     </div>
//                                  </div>
//                               </div>
//                            </Row >